/* ===========================================================
   Aki Market – theme.js
   =========================================================== */
(function () {
  'use strict';
  var cfg = window.themeConfig || { moneyFormat: '¥{{amount_no_decimals}}', cartDrawer: true, routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- 金額フォーマット ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || cfg.moneyFormat || '¥{{amount_no_decimals}}';
    function withDelims(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': val = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = withDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': val = withDelims(cents, 0, ' '); break;
      default: val = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }
  window.formatMoney = formatMoney;

  /* ---------- お知らせバー（複数メッセージの切り替え） ---------- */
  function initAnnounce() {
    $$('[data-announce]').forEach(function (bar) {
      var items = $$('.announce__item', bar);
      if (items.length < 2) return;
      var i = 0, speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- ドロワー（メニュー・カート） ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-drawer-open]');
      if (o) {
        e.preventDefault();
        if (o.dataset.drawerOpen === 'CartDrawer') { refreshCart().then(function () { openDrawer('CartDrawer'); }); }
        else openDrawer(o.dataset.drawerOpen);
        return;
      }
      var c = e.target.closest('[data-drawer-close]');
      if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
    });
    $$('[data-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = $('[data-header-search]');
        if (!s) return;
        s.classList.toggle('is-open');
        if (s.classList.contains('is-open')) { var i = $('input', s); if (i) i.focus(); }
      });
    });
  }

  /* ---------- スライドショー（ホーム画像） ---------- */
  function initSlideshows() {
    $$('[data-slideshow]').forEach(function (root) {
      var track = $('.slideshow__track', root);
      var slides = $$('.slideshow__slide', root);
      var dots = $$('.slideshow__dot', root);
      if (!track || slides.length < 2) return;
      var idx = 0, timer = null;
      function go(n, smooth) {
        idx = (n + slides.length) % slides.length;
        track.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      }
      track.addEventListener('scroll', function () {
        var n = Math.round(track.scrollLeft / track.clientWidth);
        if (n !== idx) idx = n;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
      var p = $('.slideshow__arrow--prev', root), nx = $('.slideshow__arrow--next', root);
      if (p) p.addEventListener('click', function () { go(idx - 1); restart(); });
      if (nx) nx.addEventListener('click', function () { go(idx + 1); restart(); });
      function restart() {
        if (root.dataset.autoplay !== 'true') return;
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, (parseInt(root.dataset.speed, 10) || 5) * 1000);
      }
      root.addEventListener('pointerenter', function () { clearInterval(timer); });
      root.addEventListener('pointerleave', restart);
      go(0, false);
      restart();
    });
  }

  /* ---------- もっと見る（お知らせ・レビュー） ---------- */
  function initMore() {
    $$('[data-more-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var root = btn.closest('[data-more-root]');
        var step = parseInt(btn.dataset.step, 10) || 999;
        var hidden = $$('.is-hidden', root).slice(0, step);
        hidden.forEach(function (el) { el.classList.remove('is-hidden'); });
        if (!$('.is-hidden', root)) btn.remove();
      });
    });
  }

  /* ---------- 数量ボタン ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty'); var input = $('input', wrap);
    var v = (parseInt(input.value, 10) || 1) + (b.dataset.qty === 'plus' ? 1 : -1);
    input.value = Math.max(parseInt(input.min || 1, 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ===========================================================
     商品ギャラリー
     ★ 商品ページを開いたら必ず1枚目から表示（自動で別画像に飛ばない）
     ★ 自動再生なし。画像が切り替わるのはお客様の操作時のみ
     =========================================================== */
  function Gallery(root) {
    this.root = root;
    this.track = $('.gallery__track', root);
    this.slides = $$('.gallery__slide', root);
    this.thumbs = $$('.gallery__thumb', root);
    this.counter = $('.gallery__counter', root);
    this.prev = $('.gallery__arrow--prev', root);
    this.next = $('.gallery__arrow--next', root);
    this.index = 0;
    var self = this;
    if (!this.track || !this.slides.length) return;

    // 1枚目に固定（ブラウザのスクロール位置復元・バリエーションURLの影響を無効化）
    this.reset = function () {
      self.track.style.scrollBehavior = 'auto';
      self.track.scrollLeft = 0;
      self.track.style.scrollBehavior = '';
      self.setActive(0);
    };
    // 画像の読み込みでレイアウトがずれても1枚目を維持（お客様が操作するまで）
    var userMoved = false;
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      self.root.addEventListener(ev, function () { userMoved = true; }, { passive: true });
    });
    var safeReset = function () { if (!userMoved) self.reset(); };
    this.reset();
    requestAnimationFrame(safeReset);
    window.addEventListener('load', safeReset);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { userMoved = false; } safeReset(); });
    var firstImg = $('img', this.slides[0]);
    if (firstImg && !firstImg.complete) firstImg.addEventListener('load', safeReset);

    var t;
    this.track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var n = Math.round(self.track.scrollLeft / self.track.clientWidth);
        self.setActive(n);
      }, 60);
    }, { passive: true });
    this.thumbs.forEach(function (th, i) { th.addEventListener('click', function () { userMoved = true; self.go(i); }); });
    if (this.prev) this.prev.addEventListener('click', function () { userMoved = true; self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { userMoved = true; self.go(self.index + 1); });

    // 拡大表示
    $$('.gallery__zoom', root).forEach(function (z, i) { z.addEventListener('click', function () { Lightbox.open(self.slides, i); }); });
  }
  Gallery.prototype.go = function (n) {
    n = Math.max(0, Math.min(this.slides.length - 1, n));
    this.track.scrollTo({ left: this.slides[n].offsetLeft, behavior: 'smooth' });
    this.setActive(n);
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    var i = this.slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
    if (i > -1) this.go(i);
  };
  Gallery.prototype.setActive = function (n) {
    this.index = n;
    this.thumbs.forEach(function (th, i) { th.classList.toggle('is-active', i === n); });
    var at = this.thumbs[n];
    if (at && at.parentNode) {
      var p = at.parentNode;
      var left = at.offsetLeft - p.clientWidth / 2 + at.clientWidth / 2;
      p.scrollTo({ left: left, behavior: 'smooth' });
    }
    if (this.counter) this.counter.textContent = (n + 1) + ' / ' + this.slides.length;
    if (this.prev) this.prev.disabled = n === 0;
    if (this.next) this.next.disabled = n === this.slides.length - 1;
  };

  var Lightbox = {
    el: null, imgs: [], i: 0,
    build: function () {
      if (this.el) return;
      var el = document.createElement('div');
      el.className = 'lightbox';
      el.innerHTML = '<img alt=""><button class="lightbox__close" aria-label="閉じる">✕</button><button class="lightbox__prev" aria-label="前へ">‹</button><button class="lightbox__next" aria-label="次へ">›</button>';
      document.body.appendChild(el);
      var self = this;
      el.addEventListener('click', function (e) {
        if (e.target.closest('.lightbox__prev')) return self.show(self.i - 1);
        if (e.target.closest('.lightbox__next')) return self.show(self.i + 1);
        if (e.target.tagName !== 'IMG') self.close();
      });
      this.el = el;
    },
    open: function (slides, i) {
      this.build();
      this.imgs = slides.map(function (s) { var im = $('img', s); return im ? (im.dataset.zoom || im.currentSrc || im.src) : null; }).filter(Boolean);
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.show(i);
    },
    show: function (i) { if (!this.imgs.length) return; this.i = (i + this.imgs.length) % this.imgs.length; $('img', this.el).src = this.imgs[this.i]; },
    close: function () { this.el.classList.remove('is-open'); document.body.style.overflow = ''; }
  };

  /* ===========================================================
     商品フォーム（バリエーション・まとめ買い・カート追加・追従カート）
     =========================================================== */
  function ProductForm(root) {
    var self = this;
    this.root = root;
    var json = $('[data-product-json]', root);
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    this.form = $('form.p-form', root);
    this.idInput = $('input[name="id"]', this.form);
    this.gallery = root._gallery || null;
    this.switchMedia = root.dataset.switchMedia === 'true';
    this.variant = this.product.variants.find(function (v) { return String(v.id) === String(self.idInput.value); }) || this.product.variants[0];

    $$('[data-option-index]', root).forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(true); });
    });
    $$('input[name="bundle-tier"]', root).forEach(function (r) {
      r.addEventListener('change', function () { self.updateTiers(); self.updateButton(); });
    });
    var qty = $('[data-qty-input]', root);
    if (qty) qty.addEventListener('change', function () { self.updateButton(); });

    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
    $$('[data-sticky-atc-btn]', root).forEach(function (b) {
      b.addEventListener('click', function () { self.addToCart(); });
    });
    this.initSticky();
    this.onOptionChange(false);
  }
  ProductForm.prototype.selectedOptions = function () {
    var opts = [];
    var root = this.root;
    var count = this.product.options.length;
    for (var i = 0; i < count; i++) {
      var checked = $('[data-option-index="' + i + '"]:checked', root) || $('select[data-option-index="' + i + '"]', root);
      opts.push(checked ? checked.value : this.variant.options[i]);
    }
    return opts;
  };
  ProductForm.prototype.onOptionChange = function (byUser) {
    var opts = this.selectedOptions();
    var v = this.product.variants.find(function (x) {
      return x.options.every(function (o, i) { return o === opts[i]; });
    });
    if (v) this.variant = v;
    var label;
    for (var i = 0; i < opts.length; i++) {
      label = $('[data-option-value-label="' + i + '"]', this.root);
      if (label) label.textContent = opts[i];
    }
    if (this.idInput && this.variant) this.idInput.value = this.variant.id;
    this.updateAvailability();
    this.updatePrice();
    this.updateTiers();
    this.updateButton();
    // 画像の切り替えは「お客様がバリエーションを選んだとき」だけ。ページを開いた直後は1枚目のまま。
    if (byUser && this.switchMedia && this.gallery && this.variant && this.variant.featured_media) {
      this.gallery.goToMedia(this.variant.featured_media.id);
    }
    if (byUser && this.variant && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', this.variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };
  ProductForm.prototype.updateAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    $$('[data-option-index]', this.root).forEach(function (input) {
      if (input.tagName === 'SELECT') return;
      var idx = parseInt(input.dataset.optionIndex, 10);
      var test = opts.slice(); test[idx] = input.value;
      var ok = self.product.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
      input.classList.toggle('is-unavailable', !ok);
    });
  };
  ProductForm.prototype.updatePrice = function () {
    var v = this.variant; if (!v) return;
    var self = this;
    $$('[data-price-block]', this.root).forEach(function (pb) {
      var now = $('[data-price-now]', pb), cmp = $('[data-price-compare]', pb), badge = $('[data-price-badge]', pb);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      pb.classList.toggle('price--sale', !!onSale);
      if (now) now.textContent = formatMoney(v.price);
      if (cmp) { cmp.textContent = onSale ? formatMoney(v.compare_at_price) : ''; cmp.hidden = !onSale; }
      if (badge) {
        if (onSale) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          var off = v.compare_at_price - v.price;
          badge.textContent = (badge.dataset.format || '[pct]%OFF').replace('[pct]', pct).replace('[off]', formatMoney(off));
          badge.hidden = false;
        } else { badge.hidden = true; }
      }
    });
    $$('[data-sticky-price]', this.root).forEach(function (el) { el.textContent = formatMoney(self.totalForSelection().price); });
  };

  /* まとめ買い：各プランの金額を計算 */
  ProductForm.prototype.tierVariant = function (tier) {
    var match = (tier.dataset.variantMatch || '').trim();
    if (!match) return this.variant;
    var cur = this.variant.options;
    var best = null, bestScore = -1;
    this.product.variants.forEach(function (v) {
      if (v.options.indexOf(match) === -1 && v.title.indexOf(match) === -1) return;
      var score = v.options.reduce(function (s, o, i) { return s + (o === cur[i] ? 1 : 0); }, 0);
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best || this.variant;
  };
  ProductForm.prototype.tierCalc = function (tier) {
    var qty = parseInt(tier.dataset.qty, 10) || 1;
    var fixed = parseInt(tier.dataset.fixed, 10) || 0; // 円
    var pct = parseFloat(tier.dataset.discount) || 0;
    var hasMatch = !!(tier.dataset.variantMatch || '').trim();
    var v = this.tierVariant(tier);
    var unit = v.price, unitCmp = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
    var price, compare, addQty;
    if (hasMatch) {
      // セット用バリエーション（例：「2個セット」）をそのままカートに入れる
      price = fixed > 0 ? fixed * 100 : Math.round(unit * (1 - pct / 100) / 100) * 100;
      compare = Math.max(unitCmp, this.singleCompare() * qty);
      addQty = 1;
    } else {
      price = fixed > 0 ? fixed * 100 : Math.round(unit * qty * (1 - pct / 100) / 100) * 100;
      compare = unitCmp * qty;
      addQty = qty;
    }
    return { variant: v, price: price, compare: compare, qty: addQty, label: tier.dataset.name || '' };
  };
  ProductForm.prototype.singlePrice = function () { return this.variant.price; };
  ProductForm.prototype.singleCompare = function () {
    var v = this.variant; return (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
  };
  ProductForm.prototype.updateTiers = function () {
    var self = this;
    $$('.tier', this.root).forEach(function (tier) {
      var c = self.tierCalc(tier);
      var p = $('[data-tier-price]', tier), cp = $('[data-tier-compare]', tier), sv = $('[data-tier-save]', tier), each = $('[data-tier-each]', tier);
      if (p) p.textContent = formatMoney(c.price);
      if (cp) { cp.textContent = c.compare > c.price ? formatMoney(c.compare) : ''; }
      if (sv) {
        var saved = c.compare - c.price;
        if (saved > 0) {
          var fmt = sv.dataset.format || '[off]お得';
          sv.textContent = fmt.replace('[off]', formatMoney(saved)).replace('[pct]', Math.round(saved * 100 / c.compare));
          sv.hidden = false;
        } else sv.hidden = true;
      }
      if (each) {
        var q = parseInt(tier.dataset.qty, 10) || 1;
        each.textContent = q > 1 ? '1個あたり ' + formatMoney(Math.round(c.price / q / 100) * 100) : '';
      }
      var input = $('input', tier);
      tier.classList.toggle('is-selected', !!(input && input.checked));
    });
  };
  ProductForm.prototype.totalForSelection = function () {
    var tier = $('input[name="bundle-tier"]:checked', this.root);
    if (tier) return this.tierCalc(tier.closest('.tier'));
    var q = $('[data-qty-input]', this.root);
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    return { variant: this.variant, price: this.variant.price * qty, compare: this.singleCompare() * qty, qty: qty, label: '' };
  };
  ProductForm.prototype.updateButton = function () {
    var sel = this.totalForSelection();
    var avail = sel.variant && sel.variant.available;
    // Shop Pay等の購入ボタン用にフォームの値も同期
    if (this.idInput && sel.variant) this.idInput.value = sel.variant.id;
    var fq = $('[data-form-qty]', this.root); if (fq) fq.value = sel.qty;
    $$('[data-atc]', this.root).forEach(function (b) {
      var showPrice = b.dataset.showPrice === 'true';
      var txt = avail ? (b.dataset.label || 'カートに追加する') : (b.dataset.soldout || '売り切れ');
      b.disabled = !avail;
      var t = $('[data-atc-text]', b) || b;
      t.textContent = (showPrice && avail ? formatMoney(sel.price) + ' • ' : '') + txt;
    });
    $$('[data-sticky-price]', this.root).forEach(function (el) { el.textContent = formatMoney(sel.price); });
  };
  ProductForm.prototype.addToCart = function () {
    var self = this;
    var sel = this.totalForSelection();
    if (!sel.variant || !sel.variant.available) return;
    var btns = $$('[data-atc], [data-sticky-atc-btn]', this.root);
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var err = $('[data-atc-error]', this.root); if (err) err.textContent = '';
    var item = { id: sel.variant.id, quantity: sel.qty };
    if (sel.label) item.properties = { '_まとめ買い': sel.label };
    fetch((cfg.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'カートに追加できませんでした');
        if (cfg.cartDrawer && document.getElementById('CartDrawer')) {
          return refreshCart().then(function () { openDrawer('CartDrawer'); });
        }
        window.location.href = cfg.routes.cart || '/cart';
      })
      .catch(function (e) { if (err) err.textContent = e.message; })
      .finally(function () {
        btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
        self.updateButton();
        $$('[data-sticky-atc-btn]', self.root).forEach(function (b) { b.disabled = false; });
      });
  };
  ProductForm.prototype.initSticky = function () {
    var bar = $('[data-sticky-atc]', this.root);
    var main = $('[data-atc]', this.root) || this.form;
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.footer');
    var mainVisible = true, footerVisible = false;
    var update = function () {
      var below = main.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', !mainVisible && below && !footerVisible);
    };
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting; update(); }).observe(main);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
  };

  /* ===========================================================
     カートドロワー
     =========================================================== */
  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function imgUrl(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.dataset.count = n; }); }

  function renderCart(cart) {
    setCount(cart.item_count);
    var box = $('[data-cart-items]'); if (!box) return;
    var foot = $('[data-cart-foot]');
    if (!cart.item_count) {
      box.innerHTML = '<div class="cd__empty"><p>カートは空です</p><a class="btn btn--outline" href="' + (cfg.routes.root || '/') + '">買い物を続ける</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    box.innerHTML = cart.items.map(function (it) {
      var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<div class="cd__discount">' + escapeHtml(d.discount_application.title) + '（-' + formatMoney(d.amount) + '）</div>'; }).join('');
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd__variant">' + escapeHtml(it.variant_title) + '</div>' : '';
      var orig = it.original_line_price > it.final_line_price ? ' <s class="price__compare">' + formatMoney(it.original_line_price) + '</s>' : '';
      return '<div class="cd__item" data-key="' + it.key + '">' +
        (it.image ? '<img src="' + imgUrl(it.image, 160) + '" alt="" loading="lazy">' : '<span></span>') +
        '<div><a class="cd__name" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' + variant + disc +
        '<div class="cd__row"><div class="qty"><button type="button" data-cd-qty="-1" aria-label="減らす">−</button><input type="number" min="0" value="' + it.quantity + '" data-cd-input aria-label="数量"><button type="button" data-cd-qty="1" aria-label="増やす">+</button></div>' +
        '<div><b>' + formatMoney(it.final_line_price) + '</b>' + orig + '</div></div>' +
        '<button class="cd__remove" type="button" data-cd-remove>削除</button></div></div>';
    }).join('');
    var total = $('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price);
    var cd = $('[data-cart-discounts]');
    if (cd) cd.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) { return '<div class="cd__discount">' + escapeHtml(d.title) + '（-' + formatMoney(d.total_allocated_amount) + '）</div>'; }).join('');
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }).catch(function () {});
  }
  function changeLine(key, qty) {
    return fetch((cfg.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function initCartDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.addEventListener('click', function (e) {
      var item = e.target.closest('[data-key]'); if (!item) return;
      var input = $('[data-cd-input]', item);
      var q = e.target.closest('[data-cd-qty]');
      if (q) changeLine(item.dataset.key, Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.cdQty, 10)));
      if (e.target.closest('[data-cd-remove]')) changeLine(item.dataset.key, 0);
    });
    d.addEventListener('change', function (e) {
      if (e.target.matches('[data-cd-input]')) changeLine(e.target.closest('[data-key]').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
    // 確保タイマー
    var timer = $('[data-cart-timer]', d);
    if (timer) {
      var mins = parseInt(timer.dataset.minutes, 10) || 10;
      var end;
      try { end = parseInt(sessionStorage.getItem('cartTimerEnd'), 10); } catch (e) { end = 0; }
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem('cartTimerEnd', end); } catch (e) {} }
      var out = $('b', timer);
      setInterval(function () {
        var left = Math.max(0, end - Date.now());
        if (left === 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem('cartTimerEnd', end); } catch (e) {} }
        var m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
        if (out) out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }, 1000);
    }
  }

  /* ---------- 起動 ---------- */
  function init() {
    initAnnounce();
    initDrawers();
    initSlideshows();
    initMore();
    $$('[data-gallery]').forEach(function (g) {
      var gal = new Gallery(g);
      var prod = g.closest('[data-product]');
      if (prod) prod._gallery = gal;
    });
    $$('[data-product]').forEach(function (p) { new ProductForm(p); });
    initCartDrawer();
    document.addEventListener('shopify:section:load', function (e) {
      $$('[data-gallery]', e.target).forEach(function (g) { var gal = new Gallery(g); var p = g.closest('[data-product]'); if (p) p._gallery = gal; });
      $$('[data-product]', e.target).forEach(function (p) { new ProductForm(p); });
      initSlideshows(); initMore(); initAnnounce();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
